import { Plus } from 'lucide-react';
import { LinkBase, useListContext, useTranslate } from 'ra-core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../../components/admin/data-table';
import { ImageField } from '../../../components/admin/image-field';
import { buttonVariants } from '../../../components/ui/button';
import { MoonstarList } from '../../Moonstar/MoonstarList';
import { MoonstarListActions } from '../../Moonstar/MoonstarListActions';
import { MoonstarListEmpty } from '../../Moonstar/MoonstarListEmpty';
import { SeverityAlert } from '../../Moonstar/SeverityAlert';

const MAX_SLIDES_PER_NUDGE = 15;

export const NudgeSlideList = () => {
  const { nudgeId } = useParams();
  const translate = useTranslate();

  return (
    <>
      <div className="mt-4 flex flex-col gap-4">
        <SeverityAlert severity="success">
          {translate('moonstar.nudges.slides.maxSlides', {
            max: MAX_SLIDES_PER_NUDGE,
          })}
        </SeverityAlert>
        <SeverityAlert
          severity="warning"
          title={translate('moonstar.nudges.slides.noReordering.title')}
        >
          {translate('moonstar.nudges.slides.noReordering.description')}
        </SeverityAlert>
      </div>
      <MoonstarList
        actions={<NudgeSlideListActions />}
        filter={{ nudgeId }}
        empty={<MoonstarListEmpty createTo="create" hasCreate />}
        sort={{ field: 'id', order: 'ASC' }}
      >
        <DataTable bulkActionButtons={false} rowClick={(id) => `${id}`}>
          <DataTable.Col
            source="image.src"
            disableSort
            className="w-px whitespace-nowrap"
          >
            <ImageField
              source="image.src"
              title="image.title"
              className="[&_img]:max-h-16 [&_img]:max-w-24 [&_img]:object-contain"
            />
          </DataTable.Col>
          <DataTable.Col source="content" />
          <DataTable.Col source="url" disableSort />
        </DataTable>
      </MoonstarList>
    </>
  );
};

/** A create button (relative to the slides page; the kit `CreateButton` has no `to` prop), hidden at the limit */
const NudgeSlideListActions = () => {
  const ctx = useListContext();
  const translate = useTranslate();

  if (
    !ctx.data ||
    typeof ctx.total !== 'number' ||
    ctx.total >= MAX_SLIDES_PER_NUDGE
  ) {
    return null;
  }

  return (
    <MoonstarListActions hideCreate>
      <LinkBase to="create" className={buttonVariants({ variant: 'outline' })}>
        <Plus />
        {translate('ra.action.create')}
      </LinkBase>
    </MoonstarListActions>
  );
};
